import { render, staticRenderFns } from "./BviqLogo.vue?vue&type=template&id=037a8401&scoped=true"
import script from "./BviqLogo.vue?vue&type=script&lang=ts"
export * from "./BviqLogo.vue?vue&type=script&lang=ts"
import style0 from "./BviqLogo.vue?vue&type=style&index=0&id=037a8401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037a8401",
  null
  
)

export default component.exports